export default __webpack_public_path__ + "static/media/轮播首图1.47497c39.jpg";